import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getProducts = async (appId: string, productId?: number) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/product${
      productId ? `/${productId}?appId=${appId}` : `?appId=${appId}`
    }`
  );

  return data;
};

export const createProduct = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/product?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateProduct = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/product?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const updateProductProperty = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/productproperty?appId=${appId}`,
    updateInfo
  );

  return data;
};


export const deleteProduct = async (productId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/product/${productId}`
  );

  return data;
};